import { getCurrentLocalizedTimeString } from "./time-methods";

export const dateTimeWrapper = (value: string | undefined = undefined) => {
    value = value ?? getCurrentLocalizedTimeString().substring(0, 16);

    const date = value.substring(0, 10);
    const time = value.length >= 16 ? value.substring(11, 16) : "";

    return {
        date, time, datetime: value
    };
};

export default dateTimeWrapper;